<template>
  <div class="youtube-container">
    <VuepalRemoteVideo v-slot="{ embedUrl }" :url="videoUrl">
      <div class="ratio ratio-16x9">
        <iframe
          v-if="embedUrl && isPlaying"
          :src="embedUrl"
          allow="autoplay; encrypted-media; picture-in-picture"
          allowfullscreen
          class="video-content"
        />
      </div>
    </VuepalRemoteVideo>
  </div>
</template>

<script setup lang="ts">
import type { MediaRemoteVideoFragment } from '#graphql-operations'

const props = defineProps({
  video: {
    type: Object as PropType<MediaRemoteVideoFragment>,
    default: () => {},
  },
})

const isPlaying = ref(true)
const videoUrl = computed(() => props.video?.url)
</script>

<style lang="scss">
.modal .modal-content {
  width: 100%;
}
</style>
